import { render, staticRenderFns } from "./signDocumentDialog.vue?vue&type=template&id=8848b112&scoped=true"
import script from "./signDocumentDialog.vue?vue&type=script&lang=js"
export * from "./signDocumentDialog.vue?vue&type=script&lang=js"
import style0 from "./signDocumentDialog.vue?vue&type=style&index=0&id=8848b112&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8848b112",
  null
  
)

export default component.exports